import { Link } from "react-router-dom";
import { Phone, Mail, ArrowRight } from "lucide-react";
import { FlyerActions } from "@/components/home/FlyerActions";
import { responsive } from "@/lib/media";

export const CONTACT_EMAIL = "David@docdrgadget.com";

export function FlyerBanner({ flyer, download }) {
  if (!flyer) return null;
  return (
    <section className="relative overflow-hidden border-b border-slate-800 bg-[#050B1A]" data-testid="flyer-banner">
      <div className="dg-grid-bg absolute inset-0 opacity-60" />
      <div className="pointer-events-none absolute -top-40 left-1/3 w-[min(520px,55vw)] aspect-square rounded-full bg-cyan-500/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-10 lg:py-14 grid lg:grid-cols-12 gap-8 lg:gap-12 items-center">
        <div className="lg:col-span-6 dg-reveal order-2 lg:order-1">
          <Link to="/book" className="block group" aria-label="Book a session with Dr.Gadget" data-testid="flyer-link">
            <img
              {...responsive(flyer, "(max-width: 640px) 92vw, (max-width: 1024px) 600px, 50vw")}
              alt="Dr.Gadget flyer — tech solutions, installation and remote support"
              width={1024} height={1536}
              fetchPriority="high"
              decoding="async"
              className="w-full max-w-[600px] max-h-[62vh] sm:max-h-[640px] lg:max-h-[760px] object-contain mx-auto lg:mx-0 rounded-2xl ring-1 ring-cyan-400/30 shadow-[0_30px_80px_-24px_rgba(0,160,255,0.55)] transition-transform duration-300 group-hover:scale-[1.01]"
              data-testid="flyer-image"
            />
          </Link>
          <FlyerActions flyer={download || flyer} />
        </div>
        <div className="lg:col-span-6 dg-reveal dg-reveal-2 order-1 lg:order-2">
          <span className="dg-chip"><span className="hidden sm:inline">Dr.Gadget ·&nbsp;</span>Experienced hands-on tech help</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05] font-display" data-testid="flyer-headline">
            Your tech, <span className="text-[#FFD600]">our expertise.</span>
          </h2>
          <p className="mt-4 text-slate-300 text-base sm:text-lg max-w-xl">
            TVs, camera systems, audio and home theater, Wi-Fi, computers and everyday gadgets — David has the hands-on experience to set them up and fix them. Get his help by phone or video, usually the same day.
          </p>
          <div className="mt-6 sm:mt-7 grid grid-cols-2 sm:flex sm:flex-wrap gap-3">
            <Link to="/book" className="dg-btn-primary rounded-full px-4 sm:px-6 py-3 text-sm flex items-center justify-center gap-2 whitespace-nowrap" data-testid="flyer-book-btn">
              Book a Session <ArrowRight className="w-4 h-4" />
            </Link>
            <a href="tel:+13104220669" className="dg-btn-ghost rounded-full px-4 sm:px-6 py-3 text-sm flex items-center justify-center gap-2 whitespace-nowrap" data-testid="flyer-call-btn">
              <Phone className="w-4 h-4" /> <span className="hidden sm:inline">310-422-0669</span><span className="sm:hidden">Call now</span>
            </a>
          </div>
          <a href={`mailto:${CONTACT_EMAIL}`} className="mt-5 inline-flex items-center gap-2 py-2 text-sm text-slate-400 hover:text-white transition-colors" data-testid="flyer-email-link">
            <Mail className="w-4 h-4 text-[#FFD600]" /> {CONTACT_EMAIL}
          </a>
        </div>
      </div>
    </section>
  );
}
